<template>
  <div class="wxCode">
    <div v-show="agreement" class="imgWrap" id="imgWrap">
      <!-- <Spin fix>
                <Icon type="ios-loading" size=26 class="demo-spin-icon-load"></Icon>
                <p class="wxloading">二维码加载中...</p>
            </Spin> -->
    </div>

    <section class="areenment" v-if="!agreement">
      <!-- <div class="warnWrap"></div> -->
      <div class="warnIcon">
        <div class="war-title">微信登录</div>
        <img style="border: 1px solid #e2e2e2;" src="@/assets/images/wxmonicode.png" alt="">
        <!-- <img src="@/assets/images/warning.png" alt="">
                <p class="xy">请勾选美孚协议</p> -->
      </div>
    </section>

    <div class="agreeItem line-2" :style="{'marginTop':agreement?'0':'17px'}">
      <template v-if="systemList.title">
        <Checkbox v-model="agreement" @on-change="selAgree" size="small"></Checkbox>&nbsp;
        我已阅读并同意<span class="title" @click.self="onSystem">{{"《"+systemList.title+"》"}}</span>及<span class="title" @click.self="onSecrent">{{"《"+secretList.title+"》"}}</span>
      </template>
    </div>
    <div v-if="showModal">
      <UseragreementModal ref="useragreementModal" :curItemDetails="curItemDetails" @on-close-cancel="onCloseCancel"></UseragreementModal>
    </div>
  </div>
</template>
<script>
  import api from "@/api";
  import ls from "store2";
  import UseragreementModal from "../../views/system/components/useragreement-modal.vue";
  export default {
    name: "loginForm",
    components: {
      UseragreementModal,
    },
    props: {
      phoneRules: {
        type: Array,
        default: () => {
          return [{
            required: true,
            message: "手机号不能为空",
            trigger: "blur",
          }, ];
        },
      },
      codeRules: {
        type: Array,
        default: () => {
          return [{
            required: true,
            message: "验证码不能为空",
            trigger: "blur",
          }, ];
        },
      },
    },
    data() {
      return {
        showPcode: true,
        count: 60,
        agreement: false,
        phoneFormItem: {
          password: "",
          code: "",
        },
        systemList: {},
        secretList: {},
        curItemDetails: {},
        showModal: false,
        appid: window.location.origin == "https://ocm.cloudgrow.cn" ?
          "wx5fea1723a5418580" : window.location.origin == "https://ocm.mobil.com.cn" ?
          "wx8ad187cb1df904f3" : window.location.origin ==
          "https://uat.nonprd-ocm.mobil.com.cn" ?
          "wx987d25ba9f02fff4" : "",
        urlList: window.location.origin == "https://ocm.cloudgrow.cn" ?
          "https://ocm.cloudgrow.cn/loading" : window.location.origin == "https://ocm.mobil.com.cn" ?
          "https://ocm.mobil.com.cn/loading" : window.location.origin ==
          "https://uat.nonprd-ocm.mobil.com.cn" ?
          "https://uat.nonprd-ocm.mobil.com.cn/loading" : "",
      };
    },
    computed: {
      rules() {
        return {
          phone: this.phoneRules,
          code: this.codeRules,
        };
      },
    },
    mounted() {
      setTimeout(() => {
        new WxLogin({
          self_redirect: false,
          id: "imgWrap", // 需要显示的容器id
          appid: this.appid, //"wx987d25ba9f02fff4", // 测试环境: 'wx5fea1723a5418580'
          scope: "snsapi_login", // 网页默认即可
          redirect_uri: encodeURIComponent(this.urlList), // 授权成功后回调的
          state: new Date().getTime(),
        });
      }, 800);
      this.getSystem();
      this.getSecret();
   
    },
    methods: {
      selAgree(val) {
      
      },
      handleSubmit() {
        if (!this.agreement) {
          this.$Message.info("请同意美孚OCM系统协议");
          return;
        }
        this.$refs.loginForm.validate((valid) => {
          if (valid) {
            this.$emit("on-success-valid", {
              userName: this.form.userName,
              password: this.form.password,
            });
          }
        });
      },
      getSystem() {
        api.axs(
          "get",
          `/ocm-admin/userAgreement/getPrivacyPolicy?type=${1}`
        ).then((res) => {
          if (res.code === "00000") {
            this.systemList = res.data;
          }
        });
      },
      getSecret() {
        api.axs(
          "get",
          `/ocm-admin/userAgreement/getPrivacyPolicy?type=${0}`
        ).then((res) => {
          if (res.code === "00000") {
            this.secretList = res.data;
          }
        });
      },
      onSystem() {
        this.curItemDetails = this.systemList;
        this.showModal = true;
        this.$emit("on-open-modal");
      },
      onSecrent() {
        this.curItemDetails = this.secretList;
        this.showModal = true;
        this.$emit("on-open-modal");
      },
      onCloseCancel(bool) {
        this.showModal = bool;
      },
    },
  };
</script>
<style lang="less">
  .wxCode {
    position: relative;
    text-align: center;

    .areenment {
      display: flex;
      justify-content: center;
      margin-top: 63px;
    }

    .imgWrap {
      height: 336px;
  
      overflow: hidden;
      transform: scale(.9);
      margin-top: 46px;

      .wxloading {
        font-size: 12px;
        padding: 6px 0;
        color: #0c479d;
      }
    }

    .warnWrap {
      position: absolute;
      top: 40px;
      width: 100%;
      height: 300px;
      background-color: #fff;
      opacity: 0.95;
    }

    .warnIcon {
      //   position: absolute;
      //   top: -72px;
      width: 398px;
     height: 302px;
      background: #FFFFFF;
      // font-size: 120px;
      z-index: 999;
      color: #999;
  

      // margin-top: 15px;
      .war-title {
        text-align: center;
        font-size: 20px;
        transform: scale(0.9);
        color: rgb(55, 55, 55);
      }


      &>img {
        // width: 100%;
        //  height: 100%;
        width: 250px;
        height: 250px;
        margin-top: 15px;

        object-fit: cover;
        // width: 110px;
        // margin-top: 70px;
      }

      .xy {
        color: #666;
        font-weight: bold;
        font-size: 14px;
        text-align: center;
        margin-top: -20px;
      }
    }

    .agreeItem {
      width: 392px;

      // height: 21px;
      padding-left: 8px;

      margin-bottom: 20px;
      z-index: 1000000;
      position: relative;
      top: -15px;

      .ivu-checkbox-wrapper {
        line-height: 20px;
        font-size: 12px;
        padding-right: 0;
        margin-right: 0;

        .ivu-checkbox {
          margin-top: -1px;
        }
      }

      .title {
        color: #0c479da6;
        cursor: pointer;
      }
    }
  }
</style>
<style lang="less">
  .demo-spin-icon-load {
    animation: ani-demo-spin 1s linear infinite;
  }

  @keyframes ani-demo-spin {
    from {
      transform: rotate(0deg);
    }

    50% {
      transform: rotate(180deg);
    }

    to {
      transform: rotate(360deg);
    }
  }

  .demo-spin-col {
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }
</style>